import PIETag, { ETagsColorType } from '@src/shared/components/PIETag';
import React, { ReactNode } from 'react';
import style from './TagNew.module.scss';
interface componentProps {
  children: ReactNode;
  className?: string;
}
const TagNew = ({ children, className = '' }: componentProps) => {
  return (
    <PIETag className={`${style.TagNew} ${className}`} modStrong={true}>
      {children}
    </PIETag>
  );
};

export default TagNew;
